import * as Sentry from '@sentry/react';
import { installFrontendErrorCapture } from './pages/dev/dashboard/install-frontend-error-capture';
import {
  getSentryEnvironment,
  isLocalEnvironment,
} from './utils/get-environment';

const dsn = import.meta.env.VITE_SENTRY_DSN;

if (dsn && !isLocalEnvironment()) {
  Sentry.init({
    dsn,
    environment: getSentryEnvironment(),
    release: import.meta.env.VITE_APP_VERSION,

    integrations: [
      Sentry.consoleLoggingIntegration({ levels: ['error', 'warn'] }),
    ],

    enableLogs: true,
  });
}

installFrontendErrorCapture();
